import React from "react";

export function Loader({ label = "Loading…" }) {
  return (
    <div className="loader-wrap" role="status">
      <span className="spinner" /> {label}
    </div>
  );
}

export function ErrorBox({ message, onRetry }) {
  return (
    <div className="alert error" role="alert">
      {message}
      {onRetry && (
        <button type="button" className="alert-action" onClick={onRetry}>
          Retry
        </button>
      )}
    </div>
  );
}

export function TrainingIcon() {
  return (
    <div className="training-icon">
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <rect x="3" y="4" width="18" height="12" rx="2" />
        <line x1="2" y1="20" x2="22" y2="20" />
      </svg>
    </div>
  );
}

/** Safe external link: only http(s) URLs are rendered as links. */
export const safeUrl = (url) => (typeof url === "string" && /^https?:\/\//i.test(url) ? url : null);
